__turbopack_context__.v({
  "className": "fixeldisplayfont_196fada0-module__SND6Sq__className",
  "variable": "fixeldisplayfont_196fada0-module__SND6Sq__variable",
});
